import React from "react";

export type Tone = "primary" | "success" | "warning" | "danger" | "info" | "neutral";

const iconTone: Record<Tone, string> = {
  primary: "bg-primary-soft text-primary-text",
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  danger: "bg-danger-soft text-danger",
  info: "bg-info-soft text-info",
  neutral: "bg-surface-hover text-ink-3",
};

interface StatCardProps {
  label: React.ReactNode;
  value: React.ReactNode;
  icon?: React.ReactNode;
  meta?: React.ReactNode;
  action?: React.ReactNode;
  tone?: Tone;
  loading?: boolean;
  className?: string;
}

/** KPI card: metric name, main value, supporting information and an optional action. */
export const StatCard = ({
  label,
  value,
  icon,
  meta,
  action,
  tone = "primary",
  loading = false,
  className = "",
}: StatCardProps) => (
  <div className={`zs-stat ${className}`}>
    <div className="flex items-start justify-between gap-3">
      <span className="zs-stat-label">{label}</span>
      {icon && <span className={`zs-stat-icon ${iconTone[tone]}`}>{icon}</span>}
    </div>
    {loading ? <div className="w-24 h-7 zs-skeleton" /> : <div className="zs-stat-value">{value}</div>}
    {(meta || action) && (
      <div className="flex flex-wrap items-center justify-between gap-2">
        {meta && <span className="zs-stat-meta">{meta}</span>}
        {action}
      </div>
    )}
  </div>
);
